if (typeof console === "undefined") {
	console = {};
	console.log = function (text) {
		
	};
}